import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "flex-ter-end" }

import { t } from '@/plugins/i18n'


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:visible'],
  setup(__props, { emit }) {

const props = __props





return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "custom-class": "openAuto",
    "model-value": __props.visible,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('update:visible', false))),
    draggable: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('恭喜！！！已为您开启自动续费，记得保持余额充足')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:visible', false)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})